import SessionManager from "../Session.manager";
import Global from "../../scripts/Global";
import { Channel } from "../../classes/Channel";
import DOMManager from "../DOM.manager";
import UserApi from "../../scripts/api/user.api";
import UserNotification from "../Notification/User.manager";
import { Post } from "../../classes/Post";
import PostApi from "../../scripts/api/post.api";
import ChannelApi from "../../scripts/api/channel.api";
import ChannelNotification from "../Notification/Channel.manager"

import UserSessionManager from "./Users.manager"
import VueSignals from "../../scripts/VueSignals";


let ChannelsDocs = new Array()
let ActiveChannelDoc = new Channel(null)
let PostDocs = new Array()
let PostDates = new Array()
let PublishedInvitation = []
let Invitations = []

export default class ChannelSessionManager{
    constructor(){}

    static CreateChannel(data){
        let invitation = Invitations.filter(invi => { return invi.folder_cp_id === (data.channel_id || data.folder_cp_id) });
        if (invitation.length > 0) {
            data.invitation_id = invitation[0].invitation_id;
            data.publish_user_cp_id = invitation[0].publish_user_cp_id;
        }
        if (!data.channel_id && !data.folder_cp_id && !data.cp_id) return;
        let channelDoc = new Channel(data)

        if(typeof data.user_ids != 'undefined' && data.user_ids[0] == data.user_ids[1]){
            channelDoc.reachability = SessionManager.getLoggedInUser().reachability
        }

         if(channelDoc.direct && (channelDoc.channel_name.length == 0 || channelDoc.channel_name == '' || typeof channelDoc.channel_name == 'undefined')){
            let other_user_id = data.user_ids.filter(currUserId => {return currUserId && currUserId != SessionManager.getLoggedInUserId()})

            if(other_user_id.length > 0){
                let currUser = UserSessionManager.GetUser(other_user_id[0])
                if(typeof currUser != 'undefined'){
                    channelDoc.channel_name = currUser.username
                    channelDoc.reachability = currUser.reachability
                }else {
                    UserApi.getUsers([other_user_id[0]]).then(res => {
                        if(res.data.result){
                            if(res.data.user.length >0){
                                SessionManager.createUser(res.data.user[0])
                                channelDoc.channel_name =  res.data.user[0].username
                                channelDoc.reachability = res.data.user[0].reachability
                            }
                        }
                    })
                    channelDoc.external = true
                }

            }

        }

        if(channelDoc.direct && (channelDoc.channel_name == '' || typeof channelDoc.channel_name == 'undefined')){
            if(channelDoc.user_ids.length == 1 && UserSessionManager.GetLoggedInUserId() == channelDoc.user_ids[0]){
                channelDoc.channel_name = ChannelSessionManager.GetPublishedInvitationEmail(channelDoc.channel_id)
                channelDoc.external = true
            }
        }

        if(!channelDoc.channel_name && channelDoc.direct){
            if(channelDoc.user_ids[0] != UserSessionManager.GetLoggedInUserId()){
                channelDoc.channel_name = SessionManager.getUser(channelDoc.user_ids[0]).username
            }else {
                channelDoc.channel_name = SessionManager.getUser(channelDoc.user_ids[1]).username
            }
        }

        // Add the latest message

        // Async
        if (!channelDoc.direct) {
            ChannelSessionManager.addPictureToRegularChannel(channelDoc);
        }
        // ChannelSessionManager.addLastestMessage(channelDoc);

        if(!ChannelsDocs.some(currChannel=> {return currChannel.channel_id == channelDoc.channel_id})){
            ChannelsDocs.push(channelDoc)
        }

        // Maybe its better to sort just before display, no every time a channel is created
        ChannelSessionManager.sortChannels();


        return channelDoc
    }

    static sortChannels() {
        if (Global.displayConventionalView()) {
            ChannelSessionManager.sortChannelsByActivity();
        } else {
            ChannelSessionManager.sortChannelsByName();
        }
    }

    static sortChannelsByName() {
        ChannelsDocs.sort(function(a,b){
            if(typeof a.channel_name != 'undefined'&&
            typeof b.channel_name != 'undefined'&&
            b.channel_name.toLowerCase() < a.channel_name.toLowerCase()){
                return 1
            }
            return -1;
        })
    }


    static sortChannelsByActivity() {
        ChannelsDocs.sort( (a,b) => {
            let aTime = a.latest_message_at ? a.latest_message_at : a.modified;
            let bTime = b.latest_message_at ? b.latest_message_at : b.modified;
            if (typeof aTime != 'undefined'&&
                typeof bTime != 'undefined'&&
                bTime >= aTime){
                return 1
            }
            return -1;
        })
    }

    static addLastestMessage(channelDoc) {
        PostApi.getPosts(channelDoc.channel_id, 1, 0).then(response => {
            channelDoc.last_message = response.data.posts.length > 0 ? response.data.posts[0] : null;
        });
    }

    static addPictureToRegularChannel(channelDoc) {
        ChannelApi.channelDetails(channelDoc.channel_id).then(response => {
            if (response.data.result) {
                let data = response.data.channel;
                let image_doc = '';
                if(data.image_doc != null && typeof data.image_doc.valueb64 != 'undefined'){
                    image_doc = "data"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
                    if(data.image_doc.mimetype.indexOf(":")== -1){
                        image_doc = "data:"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
                    }
                }
                channelDoc.image_doc = image_doc;
            }
        });
    }

    static UpdateExternalChannel(data){
        let channelFound = false
        for(let i=0;i <ChannelsDocs.length;i++){
            if(ChannelsDocs[i].channel_id == data.channel_id){
                ChannelsDocs[i].channel_name = data.channel_name
                ChannelsDocs[i].external = data.external
                ChannelSessionManager.SetActiveChannelById(data.channel_id)
                channelFound = true
                break
            }
        }
        if(!channelFound){
            delete data.invitation_id // remove invitation id
            ChannelSessionManager.CreateChannel(data)
            ChannelSessionManager.SetActiveChannelById(data.channel_id)
        }
    }

    static setInvitations(invitations) {
        Invitations = invitations;
        ChannelSessionManager.updateInvitations();
    }

    static updateInvitations() {
        for (let i = 0; i < Invitations.length; i++) {
            for (let j = 0; j < ChannelsDocs.length; j++) {
                if (ChannelsDocs[j].channel_id === Invitations[i].folder_cp_id) {
                    ChannelsDocs[j].invitation_id = Invitations[i].invitation_id;
                    ChannelsDocs[j].publish_user_cp_id = Invitations[i].publish_user_cp_id;
                }
            }
        }
    }

    static CreatePublishedInvitation(data){
        PublishedInvitation = data
    }

    static SetActiveChannel(channel){
        if(typeof channel != 'undefined'){
            ActiveChannelDoc = channel
            PostDocs = new Array()
            PostDates = new Array()
            Global.globalValue(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, true)
            Global.globalValue('active_channel_id', ActiveChannelDoc.channel_id)
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'channel_users')
            /** for focusing in the message area */
            if(typeof sessionStorage.getItem(VueSignals.SHOW_MODAL) != "undefined" && !sessionStorage.getItem(VueSignals.SHOW_MODAL)){
                DOMManager.RebuildChatArea()
            }
        }else {
            ChannelSessionManager.setFirstChannelActive()
        }
    }

    static SetActiveChannelById(channel_id){
        let channelFound = ChannelsDocs.find(channel => channel.channel_id === channel_id)
        if (channelFound) {
            let channel_name = channelFound.channel_name || ''
            if (Global.getRootWindow(window).location.href.indexOf('notificationrequest')  < 0 ) {
                Global.SetURLChannel(channel_id, channel_name)
                SessionManager.setActiveChannel(channelFound)
            }
            return
        } else {
            if (ChannelsDocs.length > 0)
                SessionManager.setFirstChannelActive()
        }
    }

    static SetActivePossibleChannel(channel){
        ActiveChannelDoc = channel
        Global.globalValue(VueSignals.ACTIVE_POSSIBLE_CHANGED, true)
    }


    static RemoveActiveChannel(){
        for(let i =0; i < ChannelsDocs.length;i++){
            if(ChannelsDocs[i].channel_id == active_channel.channel_id){
                ChannelsDocs[i].type = 'folder'
                ChannelsDocs[i].name = elem.channel_name
                ChannelsDocs[i].cp_id = elem.channel_id
                ChannelsDocs.splice(i ,1)
                break
            }
        }
        Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true)
        SessionManager.setFirstChannelActive()
    }


    static AddPost(data){
        let post = new Post(data)
        if(!PostDocs.some(currPost => {return currPost.post_id == post.post_id})){
            if(PostDocs.length == 0){
                PostDocs.push(post)
                PostDates.push(post.post_date)
            }
            else if(post.sqn > PostDocs[PostDocs.length-1].sqn){
                PostDocs.push(post)
                if(!PostDates.some(date => {return date == post.post_date})){
                    PostDates.push(post.post_date)
                }
            }else {
                PostDocs.unshift(post)
                if(!PostDates.some(date => {return date == post.post_date})){
                    PostDates.unshift(post.post_date)
                }
            }
        }
    }

    static UpdateActiveChannelSqn(){
        ActiveChannelDoc.sqn++
    }

    static UpdateChannelPicture(channel_id, image_doc) {
        if (channel_id == ActiveChannelDoc.channel_id) {
            ActiveChannelDoc.image_doc = image_doc;
        }
        for (let i =0; i < ChannelsDocs.length;i++){
            if (ChannelsDocs[i].channel_id == channel_id){
                ChannelsDocs[i].image_doc = image_doc;
                break;
            }
        }
    }

    static UpdateChannel(channel_id, data){
        if((channel_id == ActiveChannelDoc.channel_id && typeof data.channel_id != 'undefined') || ActiveChannelDoc.channel_id == VueSignals.DRAFT_CHANNEL_ID){
            if(typeof data.channel_name != 'undefined' || data.channel_name.length == 0 || data.channel_name == ""){
                    data.channel_name = ActiveChannelDoc.channel_name
            }
            ActiveChannelDoc = new Channel(data)
            if (!ActiveChannelDoc.last_message) {
                ChannelSessionManager.addLastestMessage(ActiveChannelDoc);
            }
            SessionManager.setActiveChannelById(data.channel_id)

            Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true)
            return
        }else {
            for(let i =0; i < ChannelsDocs.length;i++){
                if(ChannelsDocs[i].channel_id == channel_id){
                    for(let attr in data){
                        if(attr == "channel_name" && data[attr] != ''){
                            ChannelsDocs[i].channel_name = data[attr]
                            ChannelsDocs[i].flag = 'Renamed'
                        }

                        if(attr == "channel_purpose"){
                            ChannelsDocs[i].channel_purpose = data[attr]
                            ChannelsDocs[i].flag = 'Edited'
                        }

                        if(attr == "type"){
                            ChannelsDocs[i].type = data[attr]
                        }

                        if(attr == "flag"){
                            ChannelsDocs[i].flag = data[attr]
                        }

                        if(attr == "loggedinStar"){
                            ChannelsDocs[i].loggedinStar = data[attr]
                        }

                        if(attr == "user_ids"){
                            ChannelsDocs[i].user_ids = data[attr]
                        }

                        if(attr == "image_doc"){
                            if(data.image_doc != null && typeof data.image_doc.valueb64 != 'undefined'){
                                ChannelsDocs[i].image_db = data.image_doc
                                ChannelsDocs[i].image_doc = "data"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
                                if(data.image_doc.mimetype.indexOf(":")== -1){
                                    ChannelsDocs[i].image_doc = "data:"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
                                }
                            }
                        }
                    }
                    Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true)
                    break
                }
            }
        }
    }


    static DeletePost(post_id){
        return PostApi.deletePost(post_id).then(res => {
          if(res.data.result){
            for(let i=0; i<PostDocs.length;i++){
              if(PostDocs[i].post_id == post_id){
                ChannelNotification.PostDeleted(PostDocs[i].post_id,
                  ActiveChannelDoc.channel_id,
                  ActiveChannelDoc.user_ids)
                  PostDocs.splice(i, 1)
                    break
              }
            }
          }
        })
    }

    static EditPost(post_id, new_message, files){
        return PostApi.editPost(post_id, new_message, files).then(res=> {
            if(res.data.result){
              for(let i=0; i<PostDocs.length;i++){
                if(PostDocs[i].post_id == post_id){
                    PostDocs[i] = new Post(res.data.post)
                    ChannelNotification.PostEdited(PostDocs[i].post_id,
                                                  ActiveChannelDoc.channel_id,
                                                  new Post(res.data.post),
                                                  ActiveChannelDoc.user_ids)
                    break
                }
              }
            }
        })
    }


    static AddUserToChannel(channel_id, user){
        Global.globalValue(VueSignals.EVENT_USER_CHANGED, user.user_id)
        if(channel_id == ActiveChannelDoc.channel_id){
            if(!ActiveChannelDoc.user_ids.includes(user.user_id)){
                ActiveChannelDoc.user_ids.push(user.user_id)
            }

            if(typeof ActiveChannelDoc.removed_users != "undefined" && ActiveChannelDoc.removed_users.includes(user.user_id)){
                ActiveChannelDoc.removed_users.splice(ActiveChannelDoc.removed_users.indexOf(user.user_id))
            }
            UserSessionManager.CreateUser(user)
            // Global.globalValue(VueSignals.CHANNEL_USERS_CHANGED, user.user_id)
            Global.globalValue(VueSignals.CHANNEL_USERS_ACCEPTED_INVITATION, user.user_id)
            return
        }
        for(let i=0; i < ChannelsDocs.length;i++){
            if(ChannelsDocs[i].channel_id == channel_id){
                if(typeof ChannelsDocs[i].user_ids != 'undefined'){
                    if(!ChannelsDocs[i].user_ids.includes(user.user_id)){
                        ChannelsDocs[i].user_ids.push(user.user_id)
                    }
                    if(typeof ChannelsDocs[i].removed_users != "undefined" && !ChannelsDocs[i].removed_users.includes(user.user_id)){
                        ChannelsDocs[i].removed_users.splice(ChannelsDocs[i].removed_users.indexOf(user.user_id), 1)
                    }
                }
                break
            }
        }
    }


    static UpdateDirectMessageReachability(user_id, statue){
        let amoutOfUsersPresent = 1;
        // Logged in user update
        if (user_id == UserSessionManager.GetLoggedInUserId()) {
            amoutOfUsersPresent = 2;
        }
        if (ActiveChannelDoc && ActiveChannelDoc.direct) {
            if (ActiveChannelDoc.user_ids.filter(id => user_id == id).length == amoutOfUsersPresent) {
                ActiveChannelDoc.reachability = statue;
                ActiveChannelDoc.external = false;
            }
        }
        for (let i=0; i < ChannelsDocs.length; i++){
            if (ChannelsDocs[i].direct && ChannelsDocs[i].user_ids.filter(id => user_id == id).length == amoutOfUsersPresent){
                ChannelsDocs[i].reachability =  statue;
                ActiveChannelDoc.external = false;
                break;
            }
        }
        Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true);
    }

    static UpdateDirectMessageName(cp_id, new_name){
        if (typeof cp_id != 'undefind' && new_name.trim().length > 0){
            if (ActiveChannelDoc.channel_id == cp_id) {
                ActiveChannelDoc.channel_name = new_name;
                ActiveChannelDoc.external = false;
            }
            for (let i=0; i< ChannelsDocs.length; i++){
                if (ChannelsDocs[i].direct && ChannelsDocs[i].channel_id == cp_id) {
                    ChannelsDocs[i].channel_name =  new_name;
                    ChannelsDocs[i].external = false;
                    break;
                }
            }
            Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true);
        }
    }

    static UpdateDirectMessageNameWithUserId(user_id, user_name) {
        if (typeof user_name == 'string' && user_name.length > 0) {
            let amoutOfUsersPresent = 1;
            // Logged in user update
            if (user_id == UserSessionManager.GetLoggedInUserId()) {
                amoutOfUsersPresent = 2;
            }
            if (ActiveChannelDoc.direct && ActiveChannelDoc.user_ids.filter(id => id == user_id).length == amoutOfUsersPresent) {
                ActiveChannelDoc.channel_name = user_name;
                ActiveChannelDoc.external = false;
            }
            for (let i = 0; i < ChannelsDocs.length; i++) {
                if (ChannelsDocs[i].direct && ChannelsDocs[i].user_ids.filter(id => id == user_id).length == amoutOfUsersPresent) {
                    ChannelsDocs[i].channel_name = user_name;
                    ChannelsDocs[i].external = false;
                    break;
                }
            }
            Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true)
        }
     }

    static RemoveChannel(channel_id){
        if(channel_id == ActiveChannelDoc.channel_id){
            ActiveChannelDoc.flag = 'deleted'
            Global.globalValue(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, true)
            Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true)
            return
        }else {
            for(let i =0; i < ChannelsDocs.length;i++){
                if(ChannelsDocs[i].channel_id == channel_id){
                    ChannelsDocs[i].flag = 'deleted'
                    Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true)
                    break
                }
            }
        }
    }

    static DestroyChannel(channel_id){
        for(let i =0; i < ChannelsDocs.length;i++){
            if(ChannelsDocs[i].channel_id == channel_id){
                ChannelsDocs.splice(i ,1)
                SessionManager.setFirstChannelActive()
                break
            }
        }
    }

    static RemoveUserFromChannel(channel_id, user_id){
        if(ActiveChannelDoc.channel_id == channel_id){
            ActiveChannelDoc.user_ids.splice(ActiveChannelDoc.user_ids.indexOf(user_id), 1)
            ActiveChannelDoc.removed_users.push(user_id)
        }else{
            for(let i=0; i < ChannelsDocs.length;i++){
                if(ChannelsDocs[i].channel_id == channel_id){
                    ActiveChannelDoc.user_ids.splice(ActiveChannelDoc.user_ids.indexOf(user_id), 1)
                    ChannelsDocs[i].removed_users.push(user_id)
                    break
                }
            }
        }


        if(UserSessionManager.GetLoggedInUserId()  == user_id){
            ChannelSessionManager.RemoveChannel(channel_id)
        }else {
            Global.globalValue(VueSignals.EVENT_USER_CHANGED, true)
        }
    }




    static SetActiveChannelDetails(channel_doc, first_unread_post_sqn){
        ActiveChannelDoc = new Channel(channel_doc);
        ActiveChannelDoc.first_unread_post_sqn = first_unread_post_sqn;
        if (!ActiveChannelDoc.last_message) {
            ChannelSessionManager.addLastestMessage(ActiveChannelDoc);
        }
        Global.globalValue(VueSignals.CHANNEL_DETAILS_OVERRIDED, true)
        return ActiveChannelDoc
    }

    static SetReadStatus(status){
        ActiveChannelDoc.has_unread_msgs = status
    }
    static ActivateDraftChannel(){
        let loggedInUser = UserSessionManager.GetLoggedInUserDoc()
        let draftChannel =  new Channel({
            "channel_id": VueSignals.DRAFT_CHANNEL_ID,
            "creator_id": loggedInUser.user_id,
            "channel_name": loggedInUser.username,
            "direct":  true,
            "channel_purpose": "Drafts",
            "other_user_id":loggedInUser.user_id,
            "type": "draft",
            "deleted": false,
          })
          SessionManager.setActiveChannel(draftChannel)
          Global.globalValue(VueSignals.ACTIVATED_VIEW, "Folder")
    }


    static AcceptInvitation(channel_data){
        for(let i = 0; i < ChannelsDocs.length;i++){
            if(ChannelsDocs[i].channel_id == channel_data.channel_id){
                if(channel_data.channel_name.length == 0){
                    let other_user_id = channel_data.user_ids.filter(currUserId => {return (currUserId && currUserId != SessionManager.getLoggedInUserId()) })
                    let currUser = UserSessionManager.GetUser(other_user_id[0])
                    if(currUser){
                        channel_data.channel_name = currUser.username
                        channel_data.reachability = currUser.reachability
                    }
                }
                let new_channel = new Channel(channel_data)
                ChannelsDocs[i] = new_channel
                SessionManager.setActiveChannelById(ChannelsDocs[i].channel_id)
                UserNotification.UserJoined(ActiveChannelDoc.channel_id,
                                            UserSessionManager.GetLoggedInUserDoc(),
                                            ActiveChannelDoc.user_ids)
                ActiveChannelDoc.user_ids.push(UserSessionManager.user_id)
                Global.globalValue(VueSignals.INVITED_CHANNEL_ACCEPTED, ChannelsDocs[i].channel_id)
                break
            }
        }

        for (let i = 0; i < Invitations.length; i++) {
            if (Invitations[i].folder_cp_id === channel_data.channel_id) {
                Invitations.splice(i, 1);
                break;
            }
        }
    }

    static DeclineInvitation(channel_id, user_ids){
        Global.globalValue(VueSignals.REMOVE_CHANNEL, channel_id)
        UserNotification.UserLeft(channel_id, user_ids)
        for (let i = 0; i < Invitations.length; i++) {
            if (Invitations[i].folder_cp_id === channel_id) {
                Invitations.splice(i, 1);
                break;
            }
        }
    }

    static GetChannel(cid){
        for(let i=0; i < ChannelsDocs.length;i++){
            if(ChannelsDocs[i].channel_id == cid){
                return ChannelsDocs[i]
            }
        }
    }

    static GetAllChannels(){
        return ChannelsDocs
    }

    static GetActiveChannel(){ // @REFACTOR WITH while
        if(typeof ActiveChannelDoc != 'undefined'){
            if(ActiveChannelDoc.direct && !ActiveChannelDoc.channel_name){
                if(UserSessionManager.GetLoggedInUserId() == ActiveChannelDoc.user_ids[0]){
                    ActiveChannelDoc.external = true
                }

                if(!ActiveChannelDoc.channel_name){
                    ActiveChannelDoc.channel_name = SessionManager.getUser(ActiveChannelDoc.user_ids[1]).username
                }
            }
            return ActiveChannelDoc
        }
        return ChannelSessionManager.GetAllChannels()[0]
    }


    static GetActiveChannelId(){
        if(typeof ActiveChannelDoc != 'undefined'){
            return ActiveChannelDoc.channel_id
        }
        return ChannelsDocs[0].channel_id
    }

    static GetActiveChannelUserIds(){
        return ActiveChannelDoc.user_ids

    }

    static GetActiveChannelUser(user_id){
        let userDocs = new Array()
        if(typeof ActiveChannelDoc.user_ids != 'undefined'){
            for(let i=0; i<ActiveChannelDoc.user_ids.length;i++){
                userDocs.push(ChannelSessionManager.getUser(ActiveChannelDoc[i]))
            }
        }
        return userDocs
    }

    // TODO(Alex):This function is called too many times each time an user switchs channel
    static GetActiveChannelUsers(){
        let UserDocs = []
        let channel_user = null

        for(let i =0; i <ActiveChannelDoc.user_ids.length;i++){
            // TODO: When a direct channel is created , users, owners id.. are 'undefined'
            if (ActiveChannelDoc.user_ids[i]) {
                channel_user = SessionManager.getUser(ActiveChannelDoc.user_ids[i])
            } else {
                continue
            }
            if(channel_user.user_id && channel_user.user_id.length > 0 ){
                if(typeof channel_user.username == 'undefined' ||channel_user.username.length == 0){
                    channel_user.username = channel_user.email
                }
                UserDocs.push(channel_user)
            }else {
                SessionManager.makeUserCall(ActiveChannelDoc.user_ids[i]).then(res=> {
                    channel_user = SessionManager.getUser(ActiveChannelDoc.user_ids[i])
                    SessionManager.addUsertoChannel(ActiveChannelDoc.channel_id, channel_user)
                })
            }
        }
        return UserDocs
    }


    static GetAllUsersApi(arrUsers){
        let UsersCpIds = new Array()
        for(let i=0; i<ChannelsDocs.length;i++){
            if(typeof ChannelsDocs[i] != 'undefined' &&
                typeof ChannelsDocs[i].user_ids != 'undefined' &&
                ChannelsDocs[i].user_ids.length > 0){
                    for(let j=0;j<ChannelsDocs[i].user_ids.length;j++){
                        // if(UsersCpIds.indexOf(ChannelsDocs[i].user_ids[j]) < 0){
                            UsersCpIds.push(ChannelsDocs[i].user_ids[j])
                        // }
                    }
            }
        }
        // merge without duplications
        UsersCpIds = UsersCpIds.concat(arrUsers);
        UsersCpIds = [...new Set([...UsersCpIds, ...arrUsers])];
        return UserApi.getUsers(UsersCpIds)
    }

    static GetPosts(){
        return PostDocs.sort(function(a, b){
            if(typeof a.sqn != 'undefined'&&
                typeof b.sqn != 'undefined'&&
                b.sqn < a.sqn){
                return 1
            }
            return -1
        })
    }


    static PostsCall(start_at = null, direction = "down"){
        return PostApi.getPostsWithSqn(ActiveChannelDoc.channel_id, start_at, direction)
    }


    static MarkAllPostsRead(){
        return PostApi.markAllRead(ActiveChannelDoc.channel_id)
    }

    static MarkPostsRead(post_ids){
        return PostApi.markRead(ActiveChannelDoc.channel_id, post_ids)
    }

    static GetPostDates(){
        return PostDates
    }

    static GetDirectChannels(){
        let returnedArr = []
        for(let i=0; i<ChannelsDocs.length;i++){
            if(ChannelsDocs[i].direct){
                returnedArr.push(ChannelsDocs[i])
            }
        }
        return returnedArr
    }

    static GetPublishedInvitations(){
        return PublishedInvitation
    }

    static GetPublishedInvitationEmail(invitation_id = null){
        let email =   ""
            for(let i = 0; i<PublishedInvitation.length;i++)   {
                if(PublishedInvitation[i].root_folder_cp_id == invitation_id){
                    email =  PublishedInvitation[i].email
                    break
                }
            }
        return email
    }

    static GetActiveChannelOnlineUsers(){
        return UserSessionManager.GetOnlineUsers(ActiveChannelDoc.user_ids)
    }

    static Clear(){
        ChannelsDocs = new Array()
        ActiveChannelDoc = new Channel(null)
        PostDocs = new Array()
        PostDates = new Array()
    }

    static ClearPosts(){
         PostDocs = new Array()
         PostDates = new Array()
    }

    static updateCurrentChannelPicture(url) {
        if (ActiveChannelDoc) {
            ActiveChannelDoc.image_doc = url;
            for (let i=0; i < ChannelsDocs.length; i++){
                if (ChannelsDocs[i].channel_id == ActiveChannelDoc.channel_id){
                    ChannelsDocs[i].image_doc = url;
                    return;
                }
            }
            // Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true);
        }
    }

    static setChannelsLastMessage(channel_ids) {
        ChannelApi.getFirstMessages(channel_ids).then(res => {
            if (res.status) {
                let messages = res.data.posts;
                for (let i=0; i < ChannelsDocs.length; i++) {
                    ChannelsDocs[i].last_message = null;
                    for (let j = 0; j < messages.length; j++) {
                        if (ChannelsDocs[i].channel_id == messages[j].channel_id) {
                            ChannelsDocs[i].last_message = messages[j];
                            break;
                        }
                    }
                }
            }
        });
    }

    static updateDirectChannelPicture(user_id, url) {
        let amoutOfUsersPresent = 1;
        // Logged in user update
        if (user_id == UserSessionManager.GetLoggedInUserId()) {
            amoutOfUsersPresent = 2;
        }
        if (ActiveChannelDoc && ActiveChannelDoc.direct) {
            if (ActiveChannelDoc.user_ids.filter(id => user_id == id).length == amoutOfUsersPresent) {
                ActiveChannelDoc.image_doc = url;
            }
        }
        for (let i=0; i < ChannelsDocs.length; i++){
            if (ChannelsDocs[i].direct && ChannelsDocs[i].user_ids.filter(id => user_id == id).length == amoutOfUsersPresent){
                ChannelsDocs[i].image_doc = url;
                return;
            }
        }
    }

    static updateChannelsUnreadMessages() {
        ChannelApi.getMyChannels().then( res => {
            if (res.data.result) {
                let channels = res.data.channels;
                for (let i = 0; i < channels.length; i++) {
                    for (let j=0; j < ChannelsDocs.length; j++) {
                        if (channels[i].channel_id == ChannelsDocs[j].channel_id) {
                            ChannelsDocs[j].unread_count = channels[i].hasOwnProperty('unread_count') ? channels[i].unread_count : 0;
                            ChannelsDocs[j].has_unread_msgs = channels[i].hasOwnProperty('has_unread_msgs') ? channels[i].has_unread_msgs : false;
                            break;
                        }
                    }
                }
                // Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true);
            }
        });
    }
}
